"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Allow a button to behave like a checkbox, having a true / false state.
 * ngModel is required
 */
ngModule.directive('tlCheckboxButton', function () {
  var ACTIVE_CLASS = "active";
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModelCtrl) {
      //model -> UI
      ngModelCtrl.$render = function () {
        element.toggleClass(ACTIVE_CLASS, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.bind("click", function () {
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(element.hasClass(ACTIVE_CLASS) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }
      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }
      function getCheckboxValue(attributeValue, defaultValue) {
        var val = scope.$eval(attributeValue);
        return angular.isDefined(val) ? val : defaultValue;
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-checkbox-button.js
// module id = 2923
// module chunks = 13